<template>
  <div>
    <p class="mb-10 mt-10" style="font-size: 25pt; text-align: center">
      CONTACTOS
    </p>

    <!-- <p class="mb-10" style="font-size: 20pt; text-align: center">
      Este es tú espacio de configuracion, aquí puedes registrar, editar y
      administrar: <br />
      Variables, Indices, Clima a Largo Plazo y crear Publicaciones.
    </p> -->

    <v-card outlined>
      <v-toolbar flat>
        <v-btn @click="irAtras" icon>
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>

        <v-toolbar-title class="grey--text"
          >{{ contactos.length }} Contacto (s)</v-toolbar-title
        >

        <v-spacer></v-spacer>

        <v-btn class="mr-1" depressed color="primary" @click="copyEmails">
          <v-icon left dark> mdi-content-copy </v-icon>
          Copiar correos 
        </v-btn>
        <v-btn depressed color="primary" @click="addContactoDialog = true">
          <v-icon left dark> mdi-plus </v-icon>
          Agregar contacto
        </v-btn>
      </v-toolbar>
        <v-autocomplete
          v-model="filterMunicipios"
          :items="Cities"
          label="Municipio/s"
          return-object
          item-text="Name"
          multiple
          outlined
          hide-details="auto"
        ></v-autocomplete>

      <v-divider></v-divider>

      <v-card-text>
        <v-row>
          <v-col cols="12" class="pa-0">
            <v-list v-if="contactos.length > 0" two-line subheader>
              <v-list-item v-for="item in filterBy(contactos, item => filterItems(item))" :key="item.Name">
                
                  <v-checkbox v-model="item.checked"></v-checkbox>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ item.Name }} - {{item.Email}}
                  </v-list-item-title>
                  {{ item.Empresa }} - {{ item.Cargo}} - {{item.Municipios.map(municipio => getMunicipioName(municipio)).join(", ")}}
                </v-list-item-content>

                <v-list-item-action>
                  <v-menu bottom left>
                    <template v-slot:activator="{ on }">
                      <v-btn icon v-on="on">
                        <v-icon>mdi-dots-vertical</v-icon>
                      </v-btn>
                    </template>
                    <v-list dense>
                      <v-list-item @click="openDialogEditContact(item)">
                        <v-list-item-icon class="mr-3">
                          <v-icon color="blue-grey">mdi-pencil-outline</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title>Editar</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item @click="deleteContact(item.Id)">
                        <v-list-item-icon class="mr-3">
                          <v-icon color="red">mdi-delete-outline</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title>Eliminar</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </v-list-item-action>
              </v-list-item>
            </v-list>
            <div v-else class="my-2 d-flex justify-center">
              <p style="font-size: 12pt" class="mb-0">
                No hay contactos registrados, !Registra uno!
              </p>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-dialog v-model="addContactoDialog" persistent max-width="700px">
      <v-card>
        <v-toolbar flat color="primary" dark>
          <v-toolbar-title>Agregar Nuevo contacto</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="cancelDialogAddContacto()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="pb-2 pt-3">
          <v-container>
            <v-form ref="formAddContacto">
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="newContacto.Name"
                    label="Nombre"
                    outlined
                    hide-details="auto"
                    required
                    :rules="rules"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="newContacto.Empresa"
                    label="Empresa"
                    outlined
                    hide-details="auto"
                    required
                    :rules="rules"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="newContacto.Cargo"
                    label="Cargo"
                    outlined
                    hide-details="auto"
                    required
                    :rules="rules"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="newContacto.Email"
                    label="Email"
                    outlined
                    :rules="emailRule"
                  ></v-text-field>
                </v-col>
                <v-col>
                  <v-select
                    v-model="newContacto.Municipios"
                    label="Seleccionar Municipios"
                    :items="Cities"
                    item-text="Name"
                    :rules="rulesMultiple"
                    multiple
                    item-value="Id"
                  ></v-select>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="red darken-1"
            text
            large
            @click="cancelDialogAddContacto()"
            >Cancelar</v-btn
          >
          <v-btn text @click="addContacto(newContacto)" large>Guardar</v-btn>
        </v-card-actions>
        <v-overlay :absolute="true" :value="loadingAddContacto">
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
      </v-card>
    </v-dialog>


    <v-dialog v-model="showEditContact" persistent max-width="700px">
      <v-card>
        <v-toolbar flat color="primary" dark>
          <v-toolbar-title>Editar contacto</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="cancelDialogEditContact()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="pb-2 pt-3">
          <v-container>
            <v-form ref="formEditContacto">
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="contactUpdated.Name"
                    label="Nombre"
                    outlined
                    hide-details="auto"
                    required
                    :rules="rules"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="contactUpdated.Empresa"
                    label="Empresa"
                    outlined
                    hide-details="auto"
                    required
                    :rules="rules"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="contactUpdated.Cargo"
                    label="Cargo"
                    outlined
                    hide-details="auto"
                    required
                    :rules="rules"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="contactUpdated.Email"
                    label="Email"
                    outlined
                    :rules="emailRule"
                  ></v-text-field>
                </v-col>
                <v-col>
                  <v-select
                    v-model="contactUpdated.Municipios"
                    label="Seleccionar Municipios"
                    :items="Cities"
                    item-text="Name"
                    :rules="rulesMultiple"
                    multiple
                    item-value="Id"
                  ></v-select>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="red darken-1"
            text
            large
            @click="cancelDialogEditContact()"
            >Cancelar</v-btn
          >
          <v-btn text @click="updateContact(newContacto)" large>Guardar</v-btn>
        </v-card-actions>
        <v-overlay :absolute="true" :value="loadingAddContacto">
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
      </v-card>
    </v-dialog>

    <v-snackbar
      v-model="snackbar.show"
      bottom
      :color="snackbar.color"
      :timeout="5000"
      >{{ snackbar.text }}</v-snackbar
    >

    <v-overlay :value="loadingScreen">
      <v-progress-circular
        class="mb-4"
        indeterminate
        size="64"
      ></v-progress-circular>
      <p>Cargando...</p>
    </v-overlay>
  </div>
</template>

<script>
import Vue2Filters from "vue2-filters";
import api from "@/api/api";
import { Editor, EditorContent, EditorMenuBar } from "tiptap";
import { Heading, Bold } from "tiptap-extensions";

export default {
  name: "Contactos",
  mixins: [Vue2Filters.mixin],
  components: {
    EditorContent,
    EditorMenuBar,
  },
  data() {
    return {
      contactUpdated: {
        Name: "",
        Empresa:"",
        Cargo:"",
        Email:"",
        Municipios:[]
      },
      filterMunicipios:[],
      showEditContact: false,
      addContactoDialog: false,
      loadingAddContacto: false,
      newContacto: {
        Name: "",
        Empresa:"",
        Cargo:"",
        Email:"",
        Municipios:[]
      },
      contactos: [],
       Cities: [
          {
            Id: 401,
            Hash: "hn-cp-sc",
            State: { Hash: "hn-cp", Id: 4, Name: "Copán" },
            Name: "Santa Rosa de Copán",
          },
          {
            Id: 402,
            Hash: "hn-cp-ca",
            State: { Hash: "hn-cp", Id: 4, Name: "Copán" },
            Name: "Cabañas",
          },
          {
            Id: 403,
            Hash: "hn-cp-cn",
            State: { Hash: "hn-cp", Id: 4, Name: "Copán" },
            Name: "Concepción",
          },
          {
            Id: 404,
            Hash: "hn-cp-cr",
            State: { Hash: "hn-cp", Id: 4, Name: "Copán" },
            Name: "Copán Ruinas",
          },
          {
            Id: 405,
            Hash: "hn-cp-cq",
            State: { Hash: "hn-cp", Id: 4, Name: "Copán" },
            Name: "Corquín",
          },
          {
            Id: 406,
            Hash: "hn-cp-cu",
            State: { Hash: "hn-cp", Id: 4, Name: "Copán" },
            Name: "Cucuyagua",
          },
          {
            Id: 407,
            Hash: "hn-cp-do",
            State: { Hash: "hn-cp", Id: 4, Name: "Copán" },
            Name: "Dolores",
          },
          {
            Id: 408,
            Hash: "hn-cp-dn",
            State: { Hash: "hn-cp", Id: 4, Name: "Copán" },
            Name: "Dulce Nombre",
          },
          {
            Id: 409,
            Hash: "hn-cp-ep",
            State: { Hash: "hn-cp", Id: 4, Name: "Copán" },
            Name: "El Paraíso",
          },
          {
            Id: 410,
            Hash: "hn-cp-fl",
            State: { Hash: "hn-cp", Id: 4, Name: "Copán" },
            Name: "Florida",
          },
          {
            Id: 411,
            Hash: "hn-cp-lj",
            State: { Hash: "hn-cp", Id: 4, Name: "Copán" },
            Name: "La Jigua",
          },
          {
            Id: 412,
            Hash: "hn-cp-lu",
            State: { Hash: "hn-cp", Id: 4, Name: "Copán" },
            Name: "La Unión",
          },
          {
            Id: 413,
            Hash: "hn-cp-na",
            State: { Hash: "hn-cp", Id: 4, Name: "Copán" },
            Name: "Nueva Arcadia",
          },
          {
            Id: 414,
            Hash: "hn-cp-sg",
            State: { Hash: "hn-cp", Id: 4, Name: "Copán" },
            Name: "San Agustín",
          },
          {
            Id: 415,
            Hash: "hn-cp-sa",
            State: { Hash: "hn-cp", Id: 4, Name: "Copán" },
            Name: "San Antonio",
          },
          {
            Id: 416,
            Hash: "hn-cp-sm",
            State: { Hash: "hn-cp", Id: 4, Name: "Copán" },
            Name: "San Jerónimo",
          },
          {
            Id: 417,
            Hash: "hn-cp-sj",
            State: { Hash: "hn-cp", Id: 4, Name: "Copán" },
            Name: "San José",
          },
          {
            Id: 418,
            Hash: "hn-cp-so",
            State: { Hash: "hn-cp", Id: 4, Name: "Copán" },
            Name: "San Juan de Opoa",
          },
          {
            Id: 419,
            Hash: "hn-cp-sn",
            State: { Hash: "hn-cp", Id: 4, Name: "Copán" },
            Name: "San Nicolás",
          },
          {
            Id: 420,
            Hash: "hn-cp-sp",
            State: { Hash: "hn-cp", Id: 4, Name: "Copán" },
            Name: "San Pedro de Copán",
          },
          {
            Id: 421,
            Hash: "hn-cp-sr",
            State: { Hash: "hn-cp", Id: 4, Name: "Copán" },
            Name: "Santa Rita",
          },
          {
            Id: 422,
            Hash: "hn-cp-tc",
            State: { Hash: "hn-cp", Id: 4, Name: "Copán" },
            Name: "Trinidad de Copán",
          },
          {
            Id: 423,
            Hash: "hn-cp-ve",
            State: { Hash: "hn-cp", Id: 4, Name: "Copán" },
            Name: "Veracruz",
          },
          {
            Id: 601,
            Hash: "hn-ch-ch",
            State: { Hash: "hn-ch", Id: 6, Name: "Choluteca" },
            Name: "Choluteca",
          },
          {
            Id: 602,
            Hash: "hn-ch-ap",
            State: { Hash: "hn-ch", Id: 6, Name: "Choluteca" },
            Name: "Apacilagua",
          },
          {
            Id: 603,
            Hash: "hn-ch-cm",
            State: { Hash: "hn-ch", Id: 6, Name: "Choluteca" },
            Name: "Concepción de Maria",
          },
          {
            Id: 604,
            Hash: "hn-ch-du",
            State: { Hash: "hn-ch", Id: 6, Name: "Choluteca" },
            Name: "Duyure",
          },
          {
            Id: 605,
            Hash: "hn-ch-ec",
            State: { Hash: "hn-ch", Id: 6, Name: "Choluteca" },
            Name: "El Corpus",
          },
          {
            Id: 606,
            Hash: "hn-ch-et",
            State: { Hash: "hn-ch", Id: 6, Name: "Choluteca" },
            Name: "El Triunfo",
          },
          {
            Id: 607,
            Hash: "hn-ch-ma",
            State: { Hash: "hn-ch", Id: 6, Name: "Choluteca" },
            Name: "Marcovia",
          },
          {
            Id: 608,
            Hash: "hn-ch-mo",
            State: { Hash: "hn-ch", Id: 6, Name: "Choluteca" },
            Name: "Morolica",
          },
          {
            Id: 609,
            Hash: "hn-ch-na",
            State: { Hash: "hn-ch", Id: 6, Name: "Choluteca" },
            Name: "Namasigue",
          },
          {
            Id: 610,
            Hash: "hn-ch-or",
            State: { Hash: "hn-ch", Id: 6, Name: "Choluteca" },
            Name: "Orocuina",
          },
          {
            Id: 611,
            Hash: "hn-ch-pe",
            State: { Hash: "hn-ch", Id: 6, Name: "Choluteca" },
            Name: "Pespire",
          },
          {
            Id: 612,
            Hash: "hn-ch-sf",
            State: { Hash: "hn-ch", Id: 6, Name: "Choluteca" },
            Name: "San Antonio de Flores",
          },
          {
            Id: 613,
            Hash: "hn-ch-si",
            State: { Hash: "hn-ch", Id: 6, Name: "Choluteca" },
            Name: "San Isidro",
          },
          {
            Id: 614,
            Hash: "hn-ch-sj",
            State: { Hash: "hn-ch", Id: 6, Name: "Choluteca" },
            Name: "San José",
          },
          {
            Id: 615,
            Hash: "hn-ch-sm",
            State: { Hash: "hn-ch", Id: 6, Name: "Choluteca" },
            Name: "San Marcos de Colón",
          },
          {
            Id: 616,
            Hash: "hn-ch-sy",
            State: { Hash: "hn-ch", Id: 6, Name: "Choluteca" },
            Name: "Santa Ana de Yusguare",
          },
          {
            Id: 701,
            Hash: "hn-ep-yu",
            State: { Hash: "hn-ep", Id: 7, Name: "El Paraíso" },
            Name: "Yuscarán",
          },
          {
            Id: 702,
            Hash: "hn-ep-al",
            State: { Hash: "hn-ep", Id: 7, Name: "El Paraíso" },
            Name: "Alauca",
          },
          {
            Id: 705,
            Hash: "hn-ep-gu",
            State: { Hash: "hn-ep", Id: 7, Name: "El Paraíso" },
            Name: "Güinope",
          },
          {
            Id: 707,
            Hash: "hn-ep-li",
            State: { Hash: "hn-ep", Id: 7, Name: "El Paraíso" },
            Name: "Liure",
          },
          {
            Id: 708,
            Hash: "hn-ep-mo",
            State: { Hash: "hn-ep", Id: 7, Name: "El Paraíso" },
            Name: "Morocelí",
          },
          {
            Id: 709,
            Hash: "hn-ep-or",
            State: { Hash: "hn-ep", Id: 7, Name: "El Paraíso" },
            Name: "Oropolí",
          },
          {
            Id: 711,
            Hash: "hn-ep-sa",
            State: { Hash: "hn-ep", Id: 7, Name: "El Paraíso" },
            Name: "San Antonio de Flores",
          },
          {
            Id: 712,
            Hash: "hn-ep-sl",
            State: { Hash: "hn-ep", Id: 7, Name: "El Paraíso" },
            Name: "San Lucas",
          },
          {
            Id: 714,
            Hash: "hn-ep-so",
            State: { Hash: "hn-ep", Id: 7, Name: "El Paraíso" },
            Name: "Soledad",
          },
          {
            Id: 716,
            Hash: "hn-ep-tx",
            State: { Hash: "hn-ep", Id: 7, Name: "El Paraíso" },
            Name: "Texiguat",
          },
          {
            Id: 717,
            Hash: "hn-ep-va",
            State: { Hash: "hn-ep", Id: 7, Name: "El Paraíso" },
            Name: "Vado Ancho",
          },
          {
            Id: 718,
            Hash: "hn-ep-ya",
            State: { Hash: "hn-ep", Id: 7, Name: "El Paraíso" },
            Name: "Yauyupe",
          },
          {
            Id: 801,
            Hash: "hn-fm-dc",
            State: { Hash: "hn-fm", Id: 8, Name: "Francisco Morazán" },
            Name: "Distrito Central",
          },
          {
            Id: 802,
            Hash: "hn-fm-al",
            State: { Hash: "hn-fm", Id: 8, Name: "Francisco Morazán" },
            Name: "Alubarén",
          },
          {
            Id: 804,
            Hash: "hn-fm-cu",
            State: { Hash: "hn-fm", Id: 8, Name: "Francisco Morazán" },
            Name: "Curarén",
          },
          {
            Id: 807,
            Hash: "hn-fm-ll",
            State: { Hash: "hn-fm", Id: 8, Name: "Francisco Morazán" },
            Name: "La Libertad",
          },
          {
            Id: 808,
            Hash: "hn-fm-lv",
            State: { Hash: "hn-fm", Id: 8, Name: "Francisco Morazán" },
            Name: "La Venta",
          },
          {
            Id: 809,
            Hash: "hn-fm-le",
            State: { Hash: "hn-fm", Id: 8, Name: "Francisco Morazán" },
            Name: "Lepaterique",
          },
          {
            Id: 810,
            Hash: "hn-fm-mt",
            State: { Hash: "hn-fm", Id: 8, Name: "Francisco Morazán" },
            Name: "Maraita",
          },
          {
            Id: 812,
            Hash: "hn-fm-na",
            State: { Hash: "hn-fm", Id: 8, Name: "Francisco Morazán" },
            Name: "Nueva Armenia",
          },
          {
            Id: 813,
            Hash: "hn-fm-oj",
            State: { Hash: "hn-fm", Id: 8, Name: "Francisco Morazán" },
            Name: "Ojojona",
          },
          {
            Id: 815,
            Hash: "hn-fm-re",
            State: { Hash: "hn-fm", Id: 8, Name: "Francisco Morazán" },
            Name: "Reitoca",
          },
          {
            Id: 816,
            Hash: "hn-fm-sg",
            State: { Hash: "hn-fm", Id: 8, Name: "Francisco Morazán" },
            Name: "Sabanagrande",
          },
          {
            Id: 817,
            Hash: "hn-fm-so",
            State: { Hash: "hn-fm", Id: 8, Name: "Francisco Morazán" },
            Name: "San Antonio de Oriente",
          },
          {
            Id: 818,
            Hash: "hn-fm-sb",
            State: { Hash: "hn-fm", Id: 8, Name: "Francisco Morazán" },
            Name: "San Buenaventura",
          },
          {
            Id: 820,
            Hash: "hn-fm-sj",
            State: { Hash: "hn-fm", Id: 8, Name: "Francisco Morazán" },
            Name: "San Juan de Flores",
          },
          {
            Id: 821,
            Hash: "hn-fm-sm",
            State: { Hash: "hn-fm", Id: 8, Name: "Francisco Morazán" },
            Name: "San Miguelito",
          },
          {
            Id: 822,
            Hash: "hn-fm-sa",
            State: { Hash: "hn-fm", Id: 8, Name: "Francisco Morazán" },
            Name: "Santa Ana",
          },
          {
            Id: 823,
            Hash: "hn-fm-sl",
            State: { Hash: "hn-fm", Id: 8, Name: "Francisco Morazán" },
            Name: "Santa Lucía",
          },
          {
            Id: 825,
            Hash: "hn-fm-tt",
            State: { Hash: "hn-fm", Id: 8, Name: "Francisco Morazán" },
            Name: "Tatumbla",
          },
          {
            Id: 826,
            Hash: "hn-fm-va",
            State: { Hash: "hn-fm", Id: 8, Name: "Francisco Morazán" },
            Name: "Valle de Ángeles",
          },
          {
            Id: 827,
            Hash: "hn-fm-vs",
            State: { Hash: "hn-fm", Id: 8, Name: "Francisco Morazán" },
            Name: "Villa de San Francisco",
          },
          {
            Id: 1001,
            Hash: "hn-in-le",
            State: { Hash: "hn-in", Id: 10, Name: "Intibucá" },
            Name: "La Esperanza",
          },
          {
            Id: 1002,
            Hash: "hn-in-ca",
            State: { Hash: "hn-in", Id: 10, Name: "Intibucá" },
            Name: "Camasca",
          },
          {
            Id: 1003,
            Hash: "hn-in-cl",
            State: { Hash: "hn-in", Id: 10, Name: "Intibucá" },
            Name: "Colomoncagua",
          },
          {
            Id: 1004,
            Hash: "hn-in-cn",
            State: { Hash: "hn-in", Id: 10, Name: "Intibucá" },
            Name: "Concepción",
          },
          {
            Id: 1005,
            Hash: "hn-in-do",
            State: { Hash: "hn-in", Id: 10, Name: "Intibucá" },
            Name: "Dolores",
          },
          {
            Id: 1006,
            Hash: "hn-in-in",
            State: { Hash: "hn-in", Id: 10, Name: "Intibucá" },
            Name: "Intibucá",
          },
          {
            Id: 1008,
            Hash: "hn-in-md",
            State: { Hash: "hn-in", Id: 10, Name: "Intibucá" },
            Name: "Magdalena",
          },
          {
            Id: 1010,
            Hash: "hn-in-sa",
            State: { Hash: "hn-in", Id: 10, Name: "Intibucá" },
            Name: "San Antonio",
          },
          {
            Id: 1012,
            Hash: "hn-in-sj",
            State: { Hash: "hn-in", Id: 10, Name: "Intibucá" },
            Name: "San Juan",
          },
          {
            Id: 1013,
            Hash: "hn-in-ss",
            State: { Hash: "hn-in", Id: 10, Name: "Intibucá" },
            Name: "San Marcos de La Sierra",
          },
          {
            Id: 1014,
            Hash: "hn-in-sm",
            State: { Hash: "hn-in", Id: 10, Name: "Intibucá" },
            Name: "San Miguelito",
          },
          {
            Id: 1015,
            Hash: "hn-in-sl",
            State: { Hash: "hn-in", Id: 10, Name: "Intibucá" },
            Name: "Santa Lucía",
          },
          {
            Id: 1016,
            Hash: "hn-in-ya",
            State: { Hash: "hn-in", Id: 10, Name: "Intibucá" },
            Name: "Yamaranguila",
          },
          {
            Id: 1017,
            Hash: "hn-in-sf",
            State: { Hash: "hn-in", Id: 10, Name: "Intibucá" },
            Name: "San Francisco de Opalaca",
          },
          {
            Id: 1202,
            Hash: "hn-lp-ag",
            State: { Hash: "hn-lp", Id: 12, Name: "La Paz" },
            Name: "Aguanqueterique",
          },
          {
            Id: 1203,
            Hash: "hn-lp-cb",
            State: { Hash: "hn-lp", Id: 12, Name: "La Paz" },
            Name: "Cabañas",
          },
          {
            Id: 1206,
            Hash: "hn-lp-gu",
            State: { Hash: "hn-lp", Id: 12, Name: "La Paz" },
            Name: "Guajiquiro",
          },
          {
            Id: 1207,
            Hash: "hn-lp-la",
            State: { Hash: "hn-lp", Id: 12, Name: "La Paz" },
            Name: "Lauterique",
          },
          {
            Id: 1208,
            Hash: "hn-lp-ma",
            State: { Hash: "hn-lp", Id: 12, Name: "La Paz" },
            Name: "Marcala",
          },
          {
            Id: 1209,
            Hash: "hn-lp-mo",
            State: { Hash: "hn-lp", Id: 12, Name: "La Paz" },
            Name: "Mercedes de Oriente",
          },
          {
            Id: 1210,
            Hash: "hn-lp-op",
            State: { Hash: "hn-lp", Id: 12, Name: "La Paz" },
            Name: "Opatoro",
          },
          {
            Id: 1211,
            Hash: "hn-lp-sn",
            State: { Hash: "hn-lp", Id: 12, Name: "La Paz" },
            Name: "San Antonio del Norte",
          },
          {
            Id: 1213,
            Hash: "hn-lp-su",
            State: { Hash: "hn-lp", Id: 12, Name: "La Paz" },
            Name: "San Juan",
          },
          {
            Id: 1215,
            Hash: "hn-lp-sa",
            State: { Hash: "hn-lp", Id: 12, Name: "La Paz" },
            Name: "Santa Ana",
          },
          {
            Id: 1216,
            Hash: "hn-lp-se",
            State: { Hash: "hn-lp", Id: 12, Name: "La Paz" },
            Name: "Santa Elena",
          },
          {
            Id: 1219,
            Hash: "hn-lp-ya",
            State: { Hash: "hn-lp", Id: 12, Name: "La Paz" },
            Name: "Yarula",
          },
          {
            Id: 1301,
            Hash: "hn-le-gr",
            State: { Hash: "hn-le", Id: 13, Name: "Lempira" },
            Name: "Gracias",
          },
          {
            Id: 1302,
            Hash: "hn-le-be",
            State: { Hash: "hn-le", Id: 13, Name: "Lempira" },
            Name: "Belén",
          },
          {
            Id: 1303,
            Hash: "hn-le-ca",
            State: { Hash: "hn-le", Id: 13, Name: "Lempira" },
            Name: "Candelaria",
          },
          {
            Id: 1304,
            Hash: "hn-le-co",
            State: { Hash: "hn-le", Id: 13, Name: "Lempira" },
            Name: "Cololaca",
          },
          {
            Id: 1305,
            Hash: "hn-le-er",
            State: { Hash: "hn-le", Id: 13, Name: "Lempira" },
            Name: "Erandique",
          },
          {
            Id: 1306,
            Hash: "hn-le-gc",
            State: { Hash: "hn-le", Id: 13, Name: "Lempira" },
            Name: "Gualcince",
          },
          {
            Id: 1307,
            Hash: "hn-le-gt",
            State: { Hash: "hn-le", Id: 13, Name: "Lempira" },
            Name: "Guarita",
          },
          {
            Id: 1308,
            Hash: "hn-le-lc",
            State: { Hash: "hn-le", Id: 13, Name: "Lempira" },
            Name: "La Campa",
          },
          {
            Id: 1309,
            Hash: "hn-le-li",
            State: { Hash: "hn-le", Id: 13, Name: "Lempira" },
            Name: "La Iguala",
          },
          {
            Id: 1310,
            Hash: "hn-le-lf",
            State: { Hash: "hn-le", Id: 13, Name: "Lempira" },
            Name: "Las Flores",
          },
          {
            Id: 1311,
            Hash: "hn-le-lu",
            State: { Hash: "hn-le", Id: 13, Name: "Lempira" },
            Name: "La Unión",
          },
          {
            Id: 1312,
            Hash: "hn-le-lv",
            State: { Hash: "hn-le", Id: 13, Name: "Lempira" },
            Name: "La Virtud",
          },
          {
            Id: 1313,
            Hash: "hn-le-le",
            State: { Hash: "hn-le", Id: 13, Name: "Lempira" },
            Name: "Lepaera",
          },
          {
            Id: 1314,
            Hash: "hn-le-ma",
            State: { Hash: "hn-le", Id: 13, Name: "Lempira" },
            Name: "Mapulaca",
          },
          {
            Id: 1315,
            Hash: "hn-le-pi",
            State: { Hash: "hn-le", Id: 13, Name: "Lempira" },
            Name: "Piraera",
          },
          {
            Id: 1316,
            Hash: "hn-le-sa",
            State: { Hash: "hn-le", Id: 13, Name: "Lempira" },
            Name: "San Andrés",
          },
          {
            Id: 1317,
            Hash: "hn-le-sf",
            State: { Hash: "hn-le", Id: 13, Name: "Lempira" },
            Name: "San Francisco",
          },
          {
            Id: 1318,
            Hash: "hn-le-sj",
            State: { Hash: "hn-le", Id: 13, Name: "Lempira" },
            Name: "San Juan Guarita",
          },
          {
            Id: 1319,
            Hash: "hn-le-sh",
            State: { Hash: "hn-le", Id: 13, Name: "Lempira" },
            Name: "San Manuel Colohete",
          },
          {
            Id: 1320,
            Hash: "hn-le-sr",
            State: { Hash: "hn-le", Id: 13, Name: "Lempira" },
            Name: "San Rafael",
          },
          {
            Id: 1321,
            Hash: "hn-le-ss",
            State: { Hash: "hn-le", Id: 13, Name: "Lempira" },
            Name: "San Sebastián",
          },
          {
            Id: 1322,
            Hash: "hn-le-sc",
            State: { Hash: "hn-le", Id: 13, Name: "Lempira" },
            Name: "Santa Cruz",
          },
          {
            Id: 1323,
            Hash: "hn-le-tg",
            State: { Hash: "hn-le", Id: 13, Name: "Lempira" },
            Name: "Talgua",
          },
          {
            Id: 1324,
            Hash: "hn-le-tb",
            State: { Hash: "hn-le", Id: 13, Name: "Lempira" },
            Name: "Tambla",
          },
          {
            Id: 1325,
            Hash: "hn-le-to",
            State: { Hash: "hn-le", Id: 13, Name: "Lempira" },
            Name: "Tomalá",
          },
          {
            Id: 1326,
            Hash: "hn-le-va",
            State: { Hash: "hn-le", Id: 13, Name: "Lempira" },
            Name: "Valladolid",
          },
          {
            Id: 1327,
            Hash: "hn-le-vi",
            State: { Hash: "hn-le", Id: 13, Name: "Lempira" },
            Name: "Virginia",
          },
          {
            Id: 1328,
            Hash: "hn-le-sm",
            State: { Hash: "hn-le", Id: 13, Name: "Lempira" },
            Name: "San Marcos de Caiquín",
          },
          {
            Id: 1401,
            Hash: "hn-oc-oc",
            State: { Hash: "hn-oc", Id: 14, Name: "Ocotepeque" },
            Name: "Ocotepeque",
          },
          {
            Id: 1402,
            Hash: "hn-oc-bg",
            State: { Hash: "hn-oc", Id: 14, Name: "Ocotepeque" },
            Name: "Belén Gualcho",
          },
          {
            Id: 1403,
            Hash: "hn-oc-co",
            State: { Hash: "hn-oc", Id: 14, Name: "Ocotepeque" },
            Name: "Concepción",
          },
          {
            Id: 1404,
            Hash: "hn-oc-dm",
            State: { Hash: "hn-oc", Id: 14, Name: "Ocotepeque" },
            Name: "Dolores Merendón",
          },
          {
            Id: 1405,
            Hash: "hn-oc-fr",
            State: { Hash: "hn-oc", Id: 14, Name: "Ocotepeque" },
            Name: "Fraternidad",
          },
          {
            Id: 1406,
            Hash: "hn-oc-le",
            State: { Hash: "hn-oc", Id: 14, Name: "Ocotepeque" },
            Name: "La Encarnación",
          },
          {
            Id: 1407,
            Hash: "hn-oc-ll",
            State: { Hash: "hn-oc", Id: 14, Name: "Ocotepeque" },
            Name: "La Labor",
          },
          {
            Id: 1408,
            Hash: "hn-oc-lu",
            State: { Hash: "hn-oc", Id: 14, Name: "Ocotepeque" },
            Name: "Lucerna",
          },
          {
            Id: 1409,
            Hash: "hn-oc-me",
            State: { Hash: "hn-oc", Id: 14, Name: "Ocotepeque" },
            Name: "Mercedes",
          },
          {
            Id: 1410,
            Hash: "hn-oc-sf",
            State: { Hash: "hn-oc", Id: 14, Name: "Ocotepeque" },
            Name: "San Fernando",
          },
          {
            Id: 1411,
            Hash: "hn-oc-sv",
            State: { Hash: "hn-oc", Id: 14, Name: "Ocotepeque" },
            Name: "San Francisco del Valle",
          },
          {
            Id: 1412,
            Hash: "hn-oc-sj",
            State: { Hash: "hn-oc", Id: 14, Name: "Ocotepeque" },
            Name: "San Jorge",
          },
          {
            Id: 1413,
            Hash: "hn-oc-sm",
            State: { Hash: "hn-oc", Id: 14, Name: "Ocotepeque" },
            Name: "San Marcos",
          },
          {
            Id: 1414,
            Hash: "hn-oc-st",
            State: { Hash: "hn-oc", Id: 14, Name: "Ocotepeque" },
            Name: "Santa Fé",
          },
          {
            Id: 1415,
            Hash: "hn-oc-se",
            State: { Hash: "hn-oc", Id: 14, Name: "Ocotepeque" },
            Name: "Sensenti",
          },
          {
            Id: 1416,
            Hash: "hn-oc-si",
            State: { Hash: "hn-oc", Id: 14, Name: "Ocotepeque" },
            Name: "Sinuapa",
          },
          {
            Id: 1612,
            Hash: "hn-sb-il",
            State: { Hash: "hn-sb", Id: 16, Name: "Santa Bárbara" },
            Name: "Ilama",
          },
          {
            Id: 1613,
            Hash: "hn-sb-ma",
            State: { Hash: "hn-sb", Id: 16, Name: "Santa Bárbara" },
            Name: "Macuelizo",
          },
          {
            Id: 1616,
            Hash: "hn-sb-pe",
            State: { Hash: "hn-sb", Id: 16, Name: "Santa Bárbara" },
            Name: "Petoa",
          },
          {
            Id: 1628,
            Hash: "hn-sb-nf",
            State: { Hash: "hn-sb", Id: 16, Name: "Santa Bárbara" },
            Name: "Nueva Frontera",
          },
          {
            Id: 1701,
            Hash: "hn-va-na",
            State: { Hash: "hn-va", Id: 17, Name: "Valle" },
            Name: "Nacaome",
          },
          {
            Id: 1702,
            Hash: "hn-va-al",
            State: { Hash: "hn-va", Id: 17, Name: "Valle" },
            Name: "Alianza",
          },
          {
            Id: 1703,
            Hash: "hn-va-am",
            State: { Hash: "hn-va", Id: 17, Name: "Valle" },
            Name: "Amapala",
          },
          {
            Id: 1704,
            Hash: "hn-va-ar",
            State: { Hash: "hn-va", Id: 17, Name: "Valle" },
            Name: "Aramecina",
          },
          {
            Id: 1705,
            Hash: "hn-va-ca",
            State: { Hash: "hn-va", Id: 17, Name: "Valle" },
            Name: "Caridad",
          },
          {
            Id: 1706,
            Hash: "hn-va-go",
            State: { Hash: "hn-va", Id: 17, Name: "Valle" },
            Name: "Goascorán",
          },
          {
            Id: 1707,
            Hash: "hn-va-la",
            State: { Hash: "hn-va", Id: 17, Name: "Valle" },
            Name: "Langue",
          },
          {
            Id: 1708,
            Hash: "hn-va-sf",
            State: { Hash: "hn-va", Id: 17, Name: "Valle" },
            Name: "San Francisco de Coray",
          },
          {
            Id: 1709,
            Hash: "hn-va-sl",
            State: { Hash: "hn-va", Id: 17, Name: "Valle" },
            Name: "San Lorenzo",
          },
        ],
      publicaciones: [],
      formPublication: {
        indices: [],
        variables: [],
      },
      newPublication: {
        Name: {
          es: null,
        },
        Introduction: {
          es: null,
        },
        Body: {
          es: {
            First: null,
            Second: null,
          },
        },
        Indices: [],
        Variables: [],
        Data: {
          LinkImage: null,
        },
      },
      addPublicationDialog: false,
      addIndicePublication: false,
      newIndicePublicacion: {
        Indice: null,
        Body: {
          es: null,
        },
        Destacar: false,
      },
      addVariablePublication: false,
      newVariablePublicacion: {
        Variable: null,
        Body: {
          es: null,
        },
      },
      rules: [(v) => !!v || "Este campo es requerido"],
      rulesMultiple: [
        (v) => {
          if (!v || v.length < 1) {
            return "Este campo es requerido";
          } else {
            return true;
          }
        },
      ],
      emailRule: [
        (v) => {
          if (!v || v.length < 1) {
            return "Este campo es requerido";
          } 
          else if (!/^\S+@\S+\.\S+$/.test(v)) {
            return "Correo invalido";
          } else {
            return true;
          }
        },
      ],
      loadingAddPublication: false,
      updatePublicationDialog: false,
      updatePublication: null,
      editorAdd: new Editor({
        extensions: [new Heading({ levels: [1, 2, 3] }), new Bold()],
        content: "",
        onUpdate: ({ getHTML }) => {
          this.newPublication.Body.es.First = getHTML();
        },
      }),
      editorAdd2: new Editor({
        extensions: [new Heading({ levels: [1, 2, 3] }), new Bold()],
        content: "",
        onUpdate: ({ getHTML }) => {
          this.newPublication.Body.es.Second = getHTML();
        },
      }),
      editorAddIndice: new Editor({
        extensions: [new Heading({ levels: [1, 2, 3] }), new Bold()],
        content: "",
        onUpdate: ({ getHTML }) => {
          this.newIndicePublicacion.Body.es = getHTML();
        },
      }),
      editorAddVariable: new Editor({
        extensions: [new Heading({ levels: [1, 2, 3] }), new Bold()],
        content: "",
        onUpdate: ({ getHTML }) => {
          this.newVariablePublicacion.Body.es = getHTML();
        },
      }),
      snackbar: {
        show: false,
        text: null,
        color: null,
      },
      loadingScreen: false,
    };
  },
  mounted() {
    this.getContactos();
  },
  methods: {
    openDialogEditContact(contact){
      this.contactUpdated = contact;
      this.showEditContact = true
    },
    cancelDialogEditContact (){
      this.showEditContact = false;
    },
    async updateContact (){
        if (this.$refs.formEditContacto.validate()) {
        await api.updateContact(this.contactUpdated, this.contactUpdated.Id);
        this.showEditContact = false;
        this.$refs.formEditContacto.reset();
        this.getContactos();
      }
    },
    copyEmails() {
      let emails = [] 
      this.contactos.forEach( (item, index) => {
        if(item.checked)
          emails.push(item.Email)
      })
      navigator.clipboard.writeText(emails.join(", "))
      this.showSnackbar("Correos copiados", "success");
    },
    filterItems(item){
      let result = true
      if (this.filterMunicipios){
        this.filterMunicipios.forEach(municipio => {
          result = item.Municipios.includes(municipio.Id) && result;
        })
      }
      return result;
    },
    async getContactos() {
      try {
        this.loadingScreen = true;
        const data = await api.getContacts();
        if (data.data.status) {
          let contacts = data.data.data.map( contact => ({...contact, checked: false}))
          this.contactos = contacts;
        }
        this.loadingScreen = false;
      } catch (err) {
        console.log(err);
      }
    },
    async deleteContact(idContact) {
      try {
        this.loadingScreen = true;
        let data = await api.deleteContact(idContact);
        this.loadingScreen = false;
        this.showSnackbar("El contacto se eliminó correctamente", "success");
        this.getContactos();
      } catch (err) {
        console.log(err);
      }
    },
    cancelDialogAddContacto() {
      this.addContactoDialog = false;
    },
    async addContacto(newContacto) {
      if (this.$refs.formAddContacto.validate()) {
        const data = await api.addContact(newContacto);
        this.loadingAddContacto = false;
        this.addContactoDialog = false;
        this.$refs.formAddContacto.reset();
        this.getContactos();
        // }
      }
    },
    showSnackbar(message, color) {
      this.snackbar.text = message;
      this.snackbar.color = color;
      this.snackbar.show = true;
    },
    irAtras() {
      this.$router.go(-1);
    },
    getMunicipioName(idMunicipio){
      const result = this.Cities.find(municipio => municipio.Id === idMunicipio).Name  
      return result
    }
  },
  beforeDestroy() {
    // Always destroy your editor instance when it's no longer needed
    if (this.editor) {
      this.editor.destroy();
    }
  },
};
</script>